import { render, staticRenderFns } from "./addPackage.vue?vue&type=template&id=49580726"
import script from "./addPackage.vue?vue&type=script&lang=js"
export * from "./addPackage.vue?vue&type=script&lang=js"
import style0 from "./addPackage.vue?vue&type=style&index=0&id=49580726&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports